import { DatePicker, DatePickerProps } from "antd";
import dayjs from "dayjs";
import { ReactComponent as CalendarIcon } from "images/calendarIcon.svg";
import styles from "./dateInput.module.css";

export const DefaultDateInput: React.FC<DatePickerProps> = (props) => {
  const isFullView = props.placeholder && props.value !== undefined && props.value !== null;

  return (
    <>
      <DatePicker
        className={`${styles.input} ${isFullView ? styles.inputWithLabel : ""}`}
        maxDate={dayjs()}
        variant="outlined"
        format="DD.MM.YYYY"
        {...props}
        suffixIcon={props.suffixIcon ?? <CalendarIcon />}
        value={props.value ? dayjs(props.value) : undefined}
      />
      {isFullView && <span className={`${styles.label} ${styles.labelTop}`}>{props.placeholder}</span>}
    </>
  );
};
